module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNi4zNyA5Ij48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6IzM4MzgzODt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPmljX2NoZXZyb25fZG93bjwvdGl0bGU+PGcgaWQ9IkxheWVyXzIiIGRhdGEtbmFtZT0iTGF5ZXIgMiI+PGcgaWQ9IkxheWVyXzEtMiIgZGF0YS1uYW1lPSJMYXllciAxIj48cG9seWdvbiBjbGFzcz0iY2xzLTEiIHBvaW50cz0iMTQuNDkgMCA4LjE5IDYuOTMgMS45IDAgMCAwIDguMTkgOSAxNi4zNyAwIDE0LjQ5IDAiLz48L2c+PC9nPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/ic_chevron_down.svg
// module id = WBpU
// module chunks = 1